// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum MediaRequestSortKey {
	RequestDate = 0,
	Status = 1,
	ExpireDate = 2,
}

export const MediaRequestSortKeyDisplayNames: { [key in keyof typeof MediaRequestSortKey]?: string} = {
	"RequestDate": "RequestDate",
	0 : "RequestDate",
	"Status": "Status",
	1 : "Status",
	"ExpireDate": "ExpireDate",
	2 : "ExpireDate",
}

export const getMediaRequestSortKeyDisplayName = (key: MediaRequestSortKey | (keyof typeof MediaRequestSortKey & string)) => {
	return MediaRequestSortKeyDisplayNames[key];
}

